<template>
  <b-nav-item-dropdown
  
    id="dropdown-grouped"
    variant="link"
    class="dropdown-language "
    right
  >
    <template #button-content>
      <b-img
        :src="currentLocale.img"
        height="14px"
        width="22px"
        :alt="currentLocale.locale"
      />
      <span class="ml-50 text-body">{{ currentLocale.name }}</span>
    </template>
    <b-dropdown-item
      v-for="(item, index) in locales" :key="index"
      @click="changeLang(item.locale)"
    >
      <b-img
        :src="item.img"
        height="14px"
        width="22px"
        :alt="item.locale"
      />
      <span class="ml-50">{{ item.name }}</span>
    </b-dropdown-item>
  </b-nav-item-dropdown>
</template>

<script>
import { BNavItemDropdown, BDropdownItem, BImg } from 'bootstrap-vue'

export default {
  components: {
    BNavItemDropdown,
    BDropdownItem,
    BImg,
  },
  // ! Need to move this computed property to comp function once we get to Vue 3
  computed: {
    currentLocale() {
      return this.locales.find(l => l.locale === this.$i18n.locale)
    },
  },
  methods: {
      changeLang(lang) {
      this.$store.commit("i18n/SET_LANG", lang);
      this.locale = lang
    },
  },
  setup() {
    /* eslint-disable global-require */
    const locales = [
      {
        locale: 'en',
        img: require('@/assets/images/flags/en.png'),
        name: 'English',
      },
      {
        locale: 'vn',
        img: require('@/assets/images/flags/vn.png'),
        name: 'Việt Nam',
      }
    ]
    /* eslint-disable global-require */

    return {
      locales,
    }
  },
}
</script>

<style>

</style>
